module.exports = __webpack_public_path__ + "img/18_l.bfc4b39c.jpg";